import React from 'react';
import SignIn from '../../pages/SignIn';
import { useAppStore } from "../../context/state";

function ProtectedRoute({ element, children, ...props }) {
  const auth = useAppStore((state) => state.isAuth);
  // Component may be passed in as a "component" props
  const ProtectedComponent = auth ? element: SignIn
  // We return a Route component that gets added to our list of routes
  return <ProtectedComponent {...props}/>
}

export default ProtectedRoute;